import { Injectable, ViewContainerRef, EnvironmentInjector } from '@angular/core';

import { TableDashboardComponent } from '../global-components/table-dashboard/table-dashboard.component';
import { ViewComponent } from '../chart-components/view/view.component';
import { ProgressbarComponent } from '../chart-components/progressbar/progressbar.component';


@Injectable({
    providedIn: 'root'
})
export class ChartRendererService {
    constructor(private environmentInjector: EnvironmentInjector) { }

    renderChart(
        type: string,
        viewContainerRef: ViewContainerRef,
        chartData: any
    ): void {
        viewContainerRef.clear();

        let component: any;

        switch (type) {
            case 'table-dashboard':
                component = TableDashboardComponent;
                break;
            case 'view':
                component = ViewComponent;
                break;
            case 'progressbar':
                component = ProgressbarComponent;
                break;
            default:
                console.error(`Unknown chart type: ${type}`);
                return;
        }

        const componentRef = viewContainerRef.createComponent(component, {
            environmentInjector: this.environmentInjector,
        });

        if (componentRef.instance) {
            (componentRef.instance as any).data = chartData;
        }
    }
}
